import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_DETAILS = gql`
  query campaignOrderTransactionsDetails($id: ID!) {
    campaignOrderTransactionReports(where: { analytics: { campaignOrder: { id: $id } } }) {
      transactions
      revenue
      spend
      customers
      roas
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_DETAILS;
